@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.terms-container {
  padding-top: 4px;
  font-size: 12px;
  line-height: 18px;
  min-width: 244px;
}

.terms {
  grid-column-start: 2;
  padding-top: unset;
}

.popover-body {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--gray-800);
}

.popover-disclaimer {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--gray-600);
}

.popover-target {
  display: inline;
}

.icon {
  height: 10px;
  width: auto;
  color: var(--blue-600);
  padding-left: 2px;
}

.button-link {
  all: unset;
  text-decoration: underline;
  color: var(--blue-600);
}
